import { GATEWAY_ORIGIN } from '@/constants/environment';

/**
 * CRM API Configuration
 *
 * Configuration constants for CRM REST API integration.
 */

export const CRM_CONFIG = {
  /**
   * Base API endpoint
   *
   * In development: Uses Vite proxy at /api/crm to avoid CORS issues
   * In production: Uses direct HTTPS endpoint
   */
  ENDPOINT: import.meta.env.DEV ? '/api/crm' : `${GATEWAY_ORIGIN}/crm`,

  /**
   * Request timeout (milliseconds)
   */
  TIMEOUT: 10000, // 10 seconds (shorter than booking API)

  /**
   * Retry configuration
   */
  RETRY: {
    maxAttempts: 1, // No retries for newsletter
    initialDelay: 0,
  },
} as const;
